import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useCommon() {
  const queryUsers = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/users/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const queryCompany = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/companies/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getUsersAndCompanies = async (_ids) => {
    if (_ids.length === 0) return [];

    const [userResults, companyResults] = await Promise.allSettled([
      queryUsers({ _id: { $in: _ids } }, null, -1, {
        _id: 1,
        firstname: 1,
        surname: 1,
        avatar: 1,
        uri: 1,
      }),
      queryCompany({ _id: { $in: _ids } }, null, -1, {
        _id: 1,
        logo: 1,
        name: 1,
      }),
    ]);

    if (
      userResults.status !== "fulfilled" ||
      companyResults.status !== "fulfilled"
    ) {
      throw new Error("Failed to retrieve data");
    }

    let _users = userResults?.value?.data.map((_user) => ({
      _id: _user._id,
      isCompany: false,
      uri: _user.uri,
      avatar: _user.avatar,
      name: _user.firstname + " " + _user.surname ?? "",
    }));

    let _companies = companyResults?.value?.data.map((_company) => ({
      _id: _company._id,
      isCompany: true,
      uri: _company._id,
      avatar: _company.logo,
      name: _company.name,
    }));

    return _users.concat(_companies);
  };

  return {
    getUsersAndCompanies,
  };
}
